import { gql } from '@apollo/client';

import { Vehicle } from '../api.graphql';

export const ListingCreatedGQL = gql`
  subscription listingCreatedSubscription {
    listingCreated {
      id
    }
  }
`;

export const ListingUpdatedGQL = gql`
  subscription listingUpdatedSubscription {
    listingUpdated {
      id
    }
  }
`;

export const VehicleUpdatedSubscriptionGQL = gql`
  subscription VehicleUpdatedSubscription {
    vehicleUpdated {
      id
    }
  }
`;

export interface VehicleSubscriptionUpdated {
  subscriptionData: {
    data: {
      vehicleUpdated: Vehicle;
    };
  };
}
